import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
var _hoisted_1 = {
  class: "open-app-confirm-card",
  role: "dialog",
  "aria-modal": "true",
  "aria-labelledby": "open-app-confirm-title"
};
var _hoisted_2 = {
  class: "open-app-confirm-actions"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_van_overlay = _resolveComponent("van-overlay");
  return _openBlock(), _createBlock(_component_van_overlay, {
    show: $props.show,
    class: "open-app-confirm-overlay",
    "z-index": $props.zIndex,
    onClick: $options.onMaskClick
  }, {
    default: _withCtx(function () {
      return [_createElementVNode("div", {
        class: "open-app-confirm-wrap",
        onClick: _cache[2] || (_cache[2] = _withModifiers(function () {}, ["stop"]))
      }, [_createElementVNode("div", _hoisted_1, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "open-app-confirm-body"
      }, [_createElementVNode("p", {
        id: "open-app-confirm-title",
        class: "open-app-confirm-line1"
      }, "即将离开该页面"), _createElementVNode("p", {
        class: "open-app-confirm-line2"
      }, "打开“起泡”")], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("button", {
        type: "button",
        class: "open-app-confirm-btn cancel",
        onClick: _cache[0] || (_cache[0] = function () {
          return $options.onCancel && $options.onCancel.apply($options, arguments);
        })
      }, "取消"), _createElementVNode("button", {
        type: "button",
        class: "open-app-confirm-btn allow",
        onClick: _cache[1] || (_cache[1] = function () {
          return $options.onConfirm && $options.onConfirm.apply($options, arguments);
        })
      }, "允许")])])])];
    }),
    _: 1
  }, 8, ["show", "z-index", "onClick"]);
}